import en from '@/lang/translations/en.json'
import bg from '@/lang/translations/bg.json'

export default {
    en, bg
}